import { all } from "redux-saga/effects"

import userSaga from "./user/sagas"

function* socketSaga() {
  yield all([userSaga()])
}

export default socketSaga
